import { motion } from "framer-motion";
import { Check, Luggage, Users } from "lucide-react";
import { formatChf } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export default function VehicleCard({ vehicle, price, selected, onSelect, testId, note = null }) {
  const { t } = useLang();
  const i18nVeh = vehicle.id ? t(`veh.${vehicle.id}`) : null;
  const model = i18nVeh?.model || vehicle.model;
  const name = i18nVeh?.name || vehicle.name;

  return (
    <button
      type="button"
      onClick={onSelect}
      data-testid={testId}
      aria-pressed={selected}
      className={`group relative overflow-hidden rounded-2xl border bg-white text-left transition-[border-color,background-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 ${
        selected
          ? "border-miles bg-miles-ice/30 shadow-[0_18px_45px_-28px_rgba(36,87,255,0.35)]"
          : "border-ink/10 hover:border-miles/30 hover:shadow-[0_14px_35px_-28px_rgba(11,31,77,0.3)]"
      }`}
    >
      <div className="relative h-40 overflow-hidden bg-gradient-to-b from-white to-miles-ice/70 sm:h-44">
        <div className="absolute bottom-4 left-1/2 h-10 w-[68%] -translate-x-1/2 rounded-[100%] bg-miles-deep/10 blur-lg" />
        <img src={vehicle.image} alt={model} loading="eager"
          className="img-clean relative h-full w-full object-contain p-4 transition-transform duration-300 group-hover:scale-[1.025]" />
      </div>
      <div className="p-4 sm:p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="truncate text-base font-semibold tracking-tight text-ink">{name}</h3>
            <p className="mt-1 truncate text-xs text-slate">{model}</p>
          </div>
          <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-colors ${selected ? "border-miles bg-miles text-white" : "border-ink/15 text-transparent"}`}>
            <Check className="h-3 w-3" strokeWidth={2.5} />
          </span>
        </div>
        <div className="mt-4 flex items-center justify-between gap-3">
          <p className="flex items-center gap-3 text-xs font-medium text-slate">
            <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5 text-miles" /> {vehicle.pax}</span>
            <span className="flex items-center gap-1"><Luggage className="h-3.5 w-3.5 text-miles" /> {vehicle.bags}</span>
          </p>
          {price != null && <p className="font-semibold tracking-tight text-ink">{formatChf(price)}</p>}
        </div>
        {note && <p className="mt-2 text-[11px] leading-snug text-slate" data-testid={`${testId}-km-note`}>{note}</p>}
      </div>
    </button>
  );
}
